"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.OverlayDefaultHeader = void 0;
require("./OverlayDefaultHeader.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _Button = _interopRequireDefault(require("../Button/Button"));
var _TitlesDefault = _interopRequireDefault(require("../TitlesDefault/TitlesDefault"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * OverlayDefaultHeader component
 *
 * @method
 * @param { OverlayDefaultHeaderProps } props
 * @returns OverlayDefaultHeader
 */

const OverlayDefaultHeader = props => {
  const {
    description,
    externalBackActionElement,
    externalCloseActionElement,
    externalHeaderLinkElement,
    showBackButton = defaultProps.showBackButton,
    showCloseButton = defaultProps.showCloseButton,
    showHeaderDivider,
    title,
    titleSize,
    titleTag
  } = props;
  const hasTitle = !!(title || description || externalHeaderLinkElement);
  const componentClassName = (0, _classnames.default)('pal-c-OverlayDefaultHeader', {
    'pal-c-OverlayDefaultHeader--showHeaderDivider': showHeaderDivider,
    'pal-c-OverlayDefaultHeader--withBackButton': showBackButton,
    'pal-c-OverlayDefaultHeader--withTitle': hasTitle
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, showBackButton && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, externalBackActionElement && (0, _renderObject.renderObject)(externalBackActionElement), !externalBackActionElement && /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "pal-c-OverlayDefaultHeader__backButton",
    iconName: "arrowBack",
    variant: "unstyled",
    iconSize: "xl",
    ariaLabel: "Back"
  })), /*#__PURE__*/_react.default.createElement(_TitlesDefault.default, {
    headline: title,
    headlineTag: titleTag,
    description: description,
    externalAction: externalHeaderLinkElement,
    size: titleSize
  }), showCloseButton && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, externalCloseActionElement && (0, _renderObject.renderObject)(externalCloseActionElement), !externalCloseActionElement && showCloseButton && /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "pal-c-OverlayDefaultHeader__closeButton",
    iconName: "X",
    variant: "unstyled",
    iconSize: "xl",
    ariaLabel: "Close"
  })));
};

/**
 * Property type definitions
 * @typedef OverlayDefaultHeaderProps
 * @type {object}
 * @property {string} title - Title text for the overlay.
 * @property {string} description - Description text of the overlay.
 * @property {object} externalBackActionElement - Back button element on header passed from web-site with additional business and data capture logic.
 * @property {object} externalCloseActionElement - Close button element on header passed from web-site with additional business and data capture logic.
 * @property {object} externalHeaderLinkElement - Link element on header passed from web-site with additional business and data capture logic.
 * @property {boolean} showBackButton - Flag to show back button.
 * @property {boolean} showCloseButton - Flag to show close button.
 * @property {boolean} showHeaderDivider - Flag to show divider.
 * @property {string} titleSize - Size of the title - set to compact to render TitlesDefaultCompact
 * @property {string} titleTag - HTML tag of the title - default set in TitlesDefault
 */
exports.OverlayDefaultHeader = OverlayDefaultHeader;
const propTypes = exports.propTypes = {
  /**
   * Title text for the overlay.
  */
  title: _propTypes.default.string,
  /**
   * Description text of the overlay.
  */
  description: _propTypes.default.string,
  /**
   * Back button element on header passed from web-site with additional business and data capture logic.
   */
  externalBackActionElement: _propTypes.default.object,
  /**
   * Close button element on header passed from web-site with additional business and data capture logic.
   */
  externalCloseActionElement: _propTypes.default.object,
  /**
   * Link element on header passed from web-site with additional business and data capture logic.
   */
  externalHeaderLinkElement: _propTypes.default.object,
  /**
   * Flag to show back button.
   */
  showBackButton: _propTypes.default.bool,
  /**
   * Flag to show close button.
   */
  showCloseButton: _propTypes.default.bool,
  /**
   * Flag to show divider.
   */
  showHeaderDivider: _propTypes.default.bool,
  /**
   * Size of the title - set to compact to render TitlesDefaultCompact
   */
  titleSize: _propTypes.default.string,
  /**
   * HTML tag of the title - default set in TitlesDefault
   */
  titleTag: _propTypes.default.string
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {boolean} showBackButton - false: sets the default showBackButton to false
 * @property {boolean} showCloseButton - true: sets the default showCloseButton to true
 */
const defaultProps = exports.defaultProps = {
  showBackButton: false,
  showCloseButton: true
};
OverlayDefaultHeader.propTypes = propTypes;
OverlayDefaultHeader.defaultProps = defaultProps;
var _default = exports.default = OverlayDefaultHeader;